import React from 'react';
import { Instagram, MapPin, Heart } from 'lucide-react';
import './Footer.css';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/drx2byx3_Logo%20DTC.png';
const QR_URL = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://www.instagram.com/dogoseltiochepe&color=D4AF37&bgcolor=0D0D0D&format=png';

export const Footer = () => {
  return (
    <footer className="footer" data-testid="footer-section">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={LOGO_URL} alt="Dogos El Tío Chepe" className="footer-logo" data-testid="footer-logo" />
            <p className="footer-tagline">Donde el sabor se vuelve tradición</p>
          </div>

          <div className="footer-col">
            <h4>Navegación</h4>
            <a href="#productos">Menú</a>
            <a href="#experiencia">Nosotros</a>
            <a href="#galeria">Galería</a>
            <a href="#ubicacion">Ubicación</a>
          </div>

          <div className="footer-col">
            <h4>Dirección</h4>
            <p><MapPin size={13} /> Andador Álvaro Obregón #110</p>
            <p>Colonia Centro, Tapalpa</p>
            <p>Jalisco, México</p>
          </div>

          <div className="footer-col footer-col-social">
            <h4>Síguenos</h4>
            <div className="footer-qr-mini">
              <img src={QR_URL} alt="QR Instagram" data-testid="footer-qr-code" />
            </div>
            <a
              href="https://www.instagram.com/dogoseltiochepe"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-instagram"
              data-testid="instagram-link"
            >
              <Instagram size={16} />
              @dogoseltiochepe
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-fire-line" />
          <p>
            Hecho con <Heart size={12} className="footer-heart" /> en Tapalpa — Dogos El Tío Chepe {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
